<template>
  <aside
    class="info__box"
    :class="{ 'is-outlined': isOutlined, 'is-severe': isSevere }"
  >
    <section
      class="info__box_icon"
      v-if="isWarning"
    >
      <Icon name="warning" />
    </section>
    <section class="info__box_text">
      <p
        class="copy"
        v-html="content"
      />
    </section>
  </aside>
</template>

<script>
import Icon from "./Icon.vue";

export default {
  name: "InfoBox",
  components: {
    Icon,
  },
  props: {
    content: {
      type: String,
      required: true,
    },
    isOutlined: {
      type: Boolean,
      default: false,
    },
    isSevere: {
      type: Boolean,
      default: false,
    },
    isWarning: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
